// One of the two sanctioned new @material-ui imports (with AppThemeProvider): hs-check exempts src/theme/.
import { createTheme } from '@material-ui/core/styles';
import { tokens } from './tokens';

/**
 * The theme every `@material-ui/core` (v4) component and `makeStyles` callback draws with. v4 is
 * frozen, but it still paints most of the app, so it reads the same tokens as the v9 theme.
 */
export const legacyMuiTheme = createTheme({
  palette: {
    primary: tokens.primary,
    secondary: tokens.secondary
  },
  typography: {
    fontFamily: tokens.fontFamily
  },
  shape: {
    borderRadius: tokens.borderRadius
  }
});
